const local = {

    en:{
    logout:"LOGOUT",

    },

    ru:{
    logout:"ВЫХОД",

    },

    de:{
    logout:"ABMELDEN",

    },

};

export default local;